module.exports = __webpack_public_path__ + "img/course-simple.10c96b5f.png";